import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
export function Hero() {
  return <Section className="pt-20 pb-12 text-center" data-id="element-41">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1
    }} className="mb-6" data-id="element-42">
        <span className="text-sage font-bold tracking-[0.2em] text-sm uppercase" data-id="element-43">
          Calma Espiritual
        </span>
      </motion.div>

      <h1 className="text-4xl md:text-5xl font-serif font-medium leading-tight mb-6 text-warm-brown" data-id="element-44">
        Si "vibrar alto" te da ansiedad, esto es para vos.
      </h1>

      <p className="text-xl md:text-2xl text-sage font-serif italic mb-12" data-id="element-45">
        14 minutos por día. Sin mística rara. Con repetición.
      </p>

      <div className="space-y-6 text-lg md:text-xl leading-relaxed text-left md:text-center max-w-xl mx-auto mb-12 font-light" data-id="element-46">
        <p data-id="element-47">Hay un tipo de ansiedad que no se siente como "ansiedad".</p>
        <p data-id="element-48">
          Se siente como{' '}
          <strong className="font-medium text-terracotta" data-id="element-49">culpa</strong>.
        </p>
        <p data-id="element-50">
          Culpa por estar sensible.
          <br data-id="element-51" />
          Culpa por no sostener rutinas.
          <br data-id="element-52" />
          Culpa por no poder "pensar positivo" cuando por dentro estás
          acelerada.
        </p>
        <p data-id="element-53">Y lo peor: lo disfrazás de algo espiritual.</p>
        <div className="pl-4 border-l-2 border-gold/50 italic text-warm-brown/80 my-4 md:inline-block md:border-l-0 md:pl-0 md:space-x-4" data-id="element-54">
          <span className="block md:inline" data-id="element-55">"Estoy bloqueada."</span>
          <span className="block md:inline" data-id="element-56">"Estoy vibrando bajo."</span>
          <span className="block md:inline" data-id="element-57">"Me falta alineación."</span>
        </div>
        <p data-id="element-58">Pero la verdad es más simple (y más humana):</p>
        <p className="text-xl font-serif text-warm-brown" data-id="element-59">
          tu sistema está saturado… y nadie te dio una práctica que entre en tu
          vida real.
        </p>
      </div>

      <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={() => {
      document.getElementById('final-cta')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }} className="bg-terracotta text-cream px-8 py-4 rounded-full text-lg font-medium shadow-lg hover:bg-terracotta-dark transition-colors animate-breathing" data-id="element-60">
        Quiero mi Protocolo 7×7
      </motion.button>

      <div className="mt-16 flex justify-center" data-id="element-61">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-sage opacity-50" data-id="element-62">
          <path d="M12 2L12 22M12 22L5 15M12 22L19 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-63" />
        </svg>
      </div>
    </Section>;
}